import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-red-600 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">About DFF Distribution</h1>
          <p className="text-xl text-slate-200 max-w-3xl">
            Defending Freedom First through reliable wholesale distribution partnerships.
          </p>
        </div>
      </section>

      {/* Single About Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-blue-50 border border-blue-200 rounded-full">
                <i className="ri-shield-star-line text-blue-700"></i>
                <span className="text-sm font-semibold text-blue-700">Veteran-Owned Business</span>
              </div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6">Built on Service & Accountability</h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                DFF Distribution is a <strong>veteran-owned wholesale distributor</strong> serving institutional, municipal, and commercial buyers. We operate through authorized partnerships with manufacturers and distributors to support critical supply chains.
              </p>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Our approach is built on the principles that define military service: <strong>accountability, discipline, and mission focus</strong>. We prioritize long-term partnerships over transactional volume, ensuring reliable supply continuity for organizations where it matters most.
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                From municipal fleet operations to infrastructure maintenance and facilities management, we provide compliant, traceable, and professional distribution support across automotive, outdoor, hardware, and facilities categories.
              </p>
              <Link 
                to="/contact" 
                className="whitespace-nowrap inline-flex items-center justify-center px-8 py-3 bg-slate-900 text-white font-semibold rounded-md hover:bg-slate-800 transition-colors cursor-pointer"
              >
                Partner With Us
              </Link>
            </div>
            <div className="relative h-96 lg:h-full min-h-[500px]">
              <img 
                src="https://public.readdy.ai/ai/img_res/ed4dd0d19a430ce8ed7df4a940188250.jpg"
                alt="DFF Distribution - Veteran-Owned"
                className="w-full h-full object-cover object-center rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}